import React, { Fragment } from 'react';
import { useFormikContext } from 'formik';

import { useAppContext, useBeforeUnload } from '../../hooks';

import FormField from '../FormField';
import FormGroup from '../FormGroup';
import FormFooter from '../FormFooter';
import StepHeading from './StepHeading';
import FormCheckbox from '../FormCheckbox';
import PhoneFormField from './PhoneFormField';
import AcceptTOSCheckbox from '../AcceptTOSCheckbox';

function SignupFormStep3() {
  const { queryParams } = useAppContext();
  const { isSubmitting } = useFormikContext();
  useBeforeUnload(!isSubmitting);
  return (
    <Fragment>
      <StepHeading>{i18n.gettext('Tell us about yourself')}</StepHeading>
      <FormGroup style={{ marginBottom: '1rem' }}>
        <FormField name="first_name" label={i18n.gettext('First name')} />
        <FormField name="last_name" label={i18n.gettext('Last name')} />
      </FormGroup>
      <FormField
        name="email"
        type="email"
        label={i18n.gettext('Email')}
        disabled={!!queryParams.social_register}
        style={{ marginBottom: '2rem' }}
      />
      <PhoneFormField
        name="notification_phone"
        label={i18n.gettext('Mobile phone')}
        hint={i18n.gettext('For your free product tour')}
      />
      <AcceptTOSCheckbox
        name="terms_of_service_accepted"
        style={{ margin: '4rem 0 1rem' }}
      />
      <FormCheckbox
        name="newsletter_subscribe"
        hint={i18n.gettext(
          "Yes, i would like to receive resmio's newsletter to be informed about current offers and product developments."
        )}
        style={{ margin: '0 0 3rem' }}
      />
      <FormFooter submitButtonLabel={i18n.gettext('Register')} />
    </Fragment>
  );
}

export default SignupFormStep3;
